import { render, staticRenderFns } from "./TranslateLanguageLoaderV2.vue?vue&type=template&id=52e95284&scoped=true"
import script from "./TranslateLanguageLoaderV2.vue?vue&type=script&lang=js"
export * from "./TranslateLanguageLoaderV2.vue?vue&type=script&lang=js"
import style0 from "./TranslateLanguageLoaderV2.vue?vue&type=style&index=0&id=52e95284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e95284",
  null
  
)

export default component.exports